export class GlobalConstants {
    public static CONNECT_BASE_URL:string = 'https://app.campusorbit.com';
    public static GLOBAL_URL = "https://app.campusorbit.com"
}